module.exports = __webpack_public_path__ + "static/media/student-setting-password.ca72e5ac.png";